import React, { FC } from 'react';

import styled from 'styled-components';

import { SaveMyRewardsIcon } from '../icons/save-my-rewards';
import { RewardsStyleVariant, WithStyleVariant } from '../types';

const SaveMyRewardsIconContainer = styled.span`
  position: relative;
  bottom: 2px;
`;

export const BankMyRewardsLabel: FC<WithStyleVariant> = ({ variant }) => (
  <SaveMyRewardsIconContainer>
    <SaveMyRewardsIcon
      aria-hidden
      fill={variant === RewardsStyleVariant.Secondary ? Styles.color.white : Styles.color.primary}
    />
  </SaveMyRewardsIconContainer>
);
